import { render, staticRenderFns } from "./bill-receive.vue?vue&type=template&id=63dca5da"
import script from "./bill-receive.vue?vue&type=script&lang=js"
export * from "./bill-receive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports